import dayjs from 'dayjs';
import { isValidPhoneNumber } from 'react-phone-number-input';
import * as yup from 'yup';

import { DisposableDomains, FormErrors } from '@blockpulse3/data/shared';

/* ** String schema ** */
export const requiredStringField = yup
  .string()
  .trim()
  .required(FormErrors.RequiredField)
  .matches(/^[!-.?-Za-zÀ-ÖØ-öø-ÿ0-9+_\s]+$/, FormErrors.UnauthorizedChar);

/* ** UUID schema, TODO: uuid() is breaking tests, use simple string() for now ** */
export const requiredUuidField = yup.string().required();

/* ** Number format general (floats) ** */
export const numberField = yup.number();
export const requiredNumberField = yup
  .number()
  .typeError(FormErrors.RequiredField)
  .moreThan(0, FormErrors.PositiveFormat)
  .required(FormErrors.RequiredField);

/* ** Number format integer special ** */
export const requiredIntegerNumberField = yup
  .number()
  .integer(FormErrors.IntegerFormat)
  .typeError(FormErrors.RequiredField)
  .moreThan(0, FormErrors.PositiveFormat)
  .required(FormErrors.RequiredField);

/* ** Boolean schema, checkbox,radio ** */
export const requiredBooleanField = yup.boolean().required(FormErrors.RequiredField);

/* ** Email format ** */
export const requiredEmailField = yup
  .string()
  .email(FormErrors.EmailFormat)
  .trim()
  .required(FormErrors.RequiredField)
  .test('email', FormErrors.EmailDomain, (value) => {
    const domain = (value || '').split('@')[1];
    if (domain) {
      return !DisposableDomains.has(domain.toLowerCase().trim());
    }
    return false;
  });

/* ** Date format, ends today ** */
export const dateField = yup.string().test('date', FormErrors.TodayFormat, (date) => {
  const fmtDate = dayjs(date);
  return fmtDate.isValid();
});
export const requiredDateField = yup
  .string()
  .test('date', FormErrors.TodayFormat, (date) => {
    const fmtDate = dayjs(date);
    return fmtDate.isBefore(dayjs());
  })
  .required(FormErrors.RequiredField);

/* ** Birthdate format ** */
export const requiredBirthdateField = yup
  .string()
  .test('birthdate', FormErrors.ValidDateFormat, (date) => {
    const fmtDate = dayjs(date);
    return fmtDate.isBefore(dayjs()) && fmtDate.isAfter(dayjs('1900-01-01'));
  })
  .required(FormErrors.RequiredField);

/* ** Select object field ** */
export const requiredSelectField = yup
  .object({
    label: requiredStringField,
    value: requiredStringField,
  })
  .required(FormErrors.RequiredField);

/* ** Telephone field ** */
export const phoneField = yup
  .string()
  .nullable()
  .test({
    name: 'phone',
    test: (value) => (value ? isValidPhoneNumber(value) : true),
    message: FormErrors.PhoneFormat,
  });

/* ** File input field ** */
export const requiredFileField = yup.mixed().required(FormErrors.RequiredField);

/* ** Percentage format between (min) and 100% ** */
export const requiredPercentageNumberField = (min = 1): yup.NumberSchema<number | undefined> =>
  yup
    .number()
    .typeError(FormErrors.RequiredField)
    .positive(FormErrors.PositiveFormat)
    .min(min, FormErrors.PercentageFormat)
    .max(100, FormErrors.PercentageFormat)
    .required(FormErrors.RequiredField);
